<template>
  <div class="content-container">
    <b-container fluid>
      <b-row class="pt-3">
        <b-col cols="12">
          <h2>{{$t('jobAudioFile.title')}}</h2>
        </b-col>
      </b-row>
      <b-row class="mt-3 pb-3">
        <b-col cols="12">
          <audio-player
            :file="upload.fileUrl"
            :desired-time="desiredTime.toString()"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import AudioPlayer from '../general/AudioPlayer.vue';

  export default {
    components: {
      AudioPlayer,
    },
    computed: mapState({
      upload: state => state.keywordAnalysis.keywordAnalysis.transcript.job.upload,
      desiredTime: state => state.keywordAnalysis.desiredTime,
    }),
  };
</script>

<style scoped>

</style>
